import { useEffect, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { App, ConfigProvider, theme as antdTheme } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useThemeStore } from '../stores/theme.store'
import { registerMessageApi } from '../lib/app-message'
import { queryClient } from '../config/query.config'
import { env } from '../config/env.config'
import { router } from './router'
import DevToolsPanel from './devtools'
import DiagnosticsRuntimeRecorder from './devtools/diagnostics/DiagnosticsRuntimeRecorder'
import { SupplierSessionSynchronizer } from '../features/auth/session-sync'

dayjs.locale('zh-cn')

function MessageApiRegistrar() {
  const { message } = App.useApp()
  useEffect(() => {
    registerMessageApi(message)
  }, [message])
  return null
}

function AntdProvider({ children }: { children: ReactNode }) {
  const mode = useThemeStore((s) => s.mode)
  const resolvedSkin = useThemeStore((s) => s.resolvedSkin)

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm:
          mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: { colorPrimary: resolvedSkin.primary },
      }}
    >
      <App>
        <MessageApiRegistrar />
        {children}
      </App>
    </ConfigProvider>
  )
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AntdProvider>
        <SupplierSessionSynchronizer />
        {children}
        {env.dev && (
          <>
            <DiagnosticsRuntimeRecorder />
            <DevToolsPanel navigate={(to) => router.navigate(to)} />
          </>
        )}
      </AntdProvider>
    </QueryClientProvider>
  )
}
